import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const AddSpecialDateModal = ({ onClose, onSave }) => {
  const [title, setTitle] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const handleSave = () => {
    if (!title || !startDate) return;

    onSave({
      note: title,
      startDate,
      endDate: endDate || startDate,
    });

    onClose();
  };

  const toISODate = (date) => {
    if (!date) return "";
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  };

  const fromISODate = (iso) => (iso ? new Date(iso + "T00:00:00") : null);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />

      <div className="relative text-text rounded-lg shadow-xl w-full max-w-md p-6 z-10 border border-border">
        <h2 className="text-xl font-semibold mb-4 text-yellowlight">
          Add special closed date
        </h2>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-1 text-textGray">
              Reason
            </label>
            <input
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Maintenance, staff training..."
              className="w-full border rounded-md px-3 py-2 bg-dry text-sm border border-border placeholder:text-textGray"
            />
          </div>

          <div className="flex flex-col ">
            <label className="block text-sm font-medium mb-1 text-textGray">
              Start date
            </label>
            <DatePicker
              selected={fromISODate(startDate)}
              onChange={(date) => {
                const iso = toISODate(date);
                setStartDate(iso);

                // auto-fill end date if empty or earlier
                if (!endDate || endDate < iso) {
                  setEndDate(iso);
                }
              }}
              dateFormat="dd-MMM-yyyy"
              placeholderText="Select start date"
              className="w-full border rounded-md px-3 py-2 bg-dry border-border text-sm text-textGray"
              calendarClassName="bg-dry border border-border text-textGray"
              popperPlacement="bottom-start"
            />
          </div>

          <div className="flex flex-col">
            <label className="block text-sm font-medium mb-1 text-textGray">
              End date (optional)
            </label>

            <DatePicker
              selected={fromISODate(endDate)}
              onChange={(date) => {
                setEndDate(toISODate(date));
              }}
              dateFormat="dd-MMM-yyyy"
              placeholderText="Select end date"
              minDate={fromISODate(startDate)}
              className="w-full border rounded-md px-3 py-2 bg-dry border-border text-sm text-textGray"
              calendarClassName="bg-dry border border-border text-textGray"
              popperPlacement="bottom-start"
            />
          </div>
        </div>

        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={onClose}
            className="border border-border text-textGray text-sm px-4 py-2 rounded-md"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="bg-yellowlight text-yellowdark hover:bg-yellowdark hover:text-yellowlight px-4 py-2 rounded-md text-sm"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddSpecialDateModal;
